/* tslint:disable */
/* eslint-disable */
/**
 * POK
 * Opis api POK
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateUpdateEmailWithMultipleFVDto
 */
export interface CreateUpdateEmailWithMultipleFVDto {
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateEmailWithMultipleFVDto
     */
    companyId?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateUpdateEmailWithMultipleFVDto
     */
    selectedInvoices?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateEmailWithMultipleFVDto
     */
    emailSubject?: string;
}

/**
 * Check if a given object implements the CreateUpdateEmailWithMultipleFVDto interface.
 */
export function instanceOfCreateUpdateEmailWithMultipleFVDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function CreateUpdateEmailWithMultipleFVDtoFromJSON(json: any): CreateUpdateEmailWithMultipleFVDto {
    return CreateUpdateEmailWithMultipleFVDtoFromJSONTyped(json, false);
}

export function CreateUpdateEmailWithMultipleFVDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateUpdateEmailWithMultipleFVDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'companyId': !exists(json, 'companyId') ? undefined : json['companyId'],
        'selectedInvoices': !exists(json, 'selectedInvoices') ? undefined : json['selectedInvoices'],
        'emailSubject': !exists(json, 'emailSubject') ? undefined : json['emailSubject'],
    };
}

export function CreateUpdateEmailWithMultipleFVDtoToJSON(value?: CreateUpdateEmailWithMultipleFVDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'companyId': value.companyId,
        'selectedInvoices': value.selectedInvoices,
        'emailSubject': value.emailSubject,
    };
}

